import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Heading } from '@radix-ui/themes';

import useNotificationPreferences from './hooks/useNotificationPreferences';
import { isAdmin } from '../../lib/utils/roles';
import NotificationSection from './components/NotificationSection';
import { useNotificationConfig } from './config/notificationConfig';
import styles from './NotificationPreferences.module.css';
import SectionCard from '../../shared/SectionCard';

export default function AdminNotificationPreferences() {
  const { t } = useTranslation('accountSettings');
  const { userType } = useSelector(state => state.currentUser);
  const isUserAdmin = isAdmin(userType);

  const { values, handleChange, isLoading } = useNotificationPreferences();

  const handleRowClick = fieldName => {
    handleChange({
      target: { name: fieldName, checked: !values[fieldName] },
    });
  };

  const notificationConfig = useNotificationConfig(isUserAdmin);

  if (isLoading) {
    return (
      <div className={styles.container}>
        <Heading size="4" className={styles.heading}>
          {t('notificationPreferences.title')}
        </Heading>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <>
      {isUserAdmin && (
        <>
          <SectionCard title={t('notificationPreferences.title')}>
            <NotificationSection
              items={notificationConfig.emailNotifications.items}
              values={values}
              onChange={handleChange}
              onItemClick={handleRowClick}
            />
          </SectionCard>
        </>
      )}
    </>
  );
}
